// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ohtr","content":"styles_content__8dMK0","tableWrap":"styles_tableWrap__3ND3w"};